import events from '@/constants/events'
import editManager from '@/editManager'
import EventBus from '@/EventBus'

const initializeTabVisibilityEvents = () => {
  window.addEventListener('focus', () => EventBus.$emit(events.TAB_FOCUS))
  window.addEventListener('blur', () => EventBus.$emit(events.TAB_BLUR))
}

const initAutoRefresh = () => {
  let hiddenAt = null
  const autoRefreshTimeout = 240 // in minutes

  const reloadOnTimeout = () => {
    const millisInMinutes = 1000 * 60
    const timeDiff = (Date.now() - hiddenAt) / millisInMinutes
    if (timeDiff > autoRefreshTimeout && !editManager.hasEdits()) {
      window.location.reload()
    }
  }

  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible' && hiddenAt) {
      reloadOnTimeout()
    } else {
      hiddenAt = Date.now()
    }
  })

  EventBus.$on(events.TAB_FOCUS, () => hiddenAt && reloadOnTimeout())
  EventBus.$on(events.TAB_BLUR, () => (hiddenAt = Date.now()))
}

initAutoRefresh()
initializeTabVisibilityEvents()
